/**
 * message operations
 * 
 * @author    Jens Gruschel, Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


import {clearMessageAction, showMessageAction, showDialogMessageAction, clearDialogMessageAction} from "../redux/message/actions";


export function showMessage(message) {
    return dispatch => {
        dispatch(showMessageAction(message));
    }
}

export function clearMessage() {
    return dispatch => {
        dispatch(clearMessageAction());
    }
}

export function showError(error) {
    return dispatch => {
        console.log("error:", error);

        let message = error.message || error.msg || error

        dispatch(showMessageAction(message));
    }
}

export function showDialogMessage(title, message) {
    return dispatch => {
        dispatch(showDialogMessageAction(title, message));
    }
}

export function clearDialogMessage() {
    return dispatch => {
        dispatch(clearDialogMessageAction());
    }
}